"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _PrimaryText = _interopRequireDefault(require("../../TextElements/BasicTextElements/PrimaryText"));

var _AppInfoModal = require("./AppInfoModal.styles");

var _formatters = require("../../../helpers/formatters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * An application information window, displaying associated libraries.
 * <br /><br />
 * The format for libInfo should look like: <br /><br />
 * {<br />
 * &nbsp;version: <string\>,<br />
 * &nbsp;dependencies: <object\>,<br />
 * &nbsp;devDependencies: <object\>,<br />
 * &nbsp;peerDependencies: <object\>,<br />
 * &nbsp;bundledDependencies: <object\>,<br />
 * &nbsp;optionalDependencies: <object\>,<br />
 * }
 * <br /><br />
 * The values for the objects above should be collections of name value pairs, so something like this
 * (both are acceptable):
 * <br /><br />
 * {<br />
 * &nbsp;"@babel/0_rootStyleAttributes": "^7.1.6",<br />
 * &nbsp;"babel-jest": "23.6.0",<br />
 * }
 * <br /><br />
 * **There is a helper function in the `fe-shared-libs` project that can be utilized to generate this data.**
 */
var AppInfoModal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AppInfoModal, _React$PureComponent);

  var _super = _createSuper(AppInfoModal);

  function AppInfoModal(props) {
    var _this;

    _classCallCheck(this, AppInfoModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "processKey", function (e) {
      var thisPress = Date.now();
      var _this$props = _this.props,
          accessCode = _this$props.accessCode,
          keyDelay = _this$props.keyDelay;

      if (thisPress - _this.lastPress > keyDelay) {
        _this.codeStep = 0;
      }

      if (accessCode[_this.codeStep] === e.key) {
        _this.codeStep++;

        if (_this.codeStep >= accessCode.length) {
          _this.codeStep = 0;

          _this.setState({
            isVisible: true
          });
        }
      }

      _this.lastPress = thisPress;
    });

    _defineProperty(_assertThisInitialized(_this), "buildInfoSections", function (libInfo) {
      var plainTextTitles = {
        dependencies: 'Direct Dependencies',
        devDependencies: 'Dev Dependencies',
        peerDependencies: 'Peer Dependencies',
        bundledDependencies: 'Bundled Dependencies',
        optionalDependencies: 'Optional Dependencies'
      };
      return Object.keys(libInfo).map(function (key) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "".concat(key, "-section")
        }, /*#__PURE__*/_react.default.createElement(_PrimaryText.default, {
          dataTestId: "".concat(key, "-section")
        }, /*#__PURE__*/_react.default.createElement("strong", null, plainTextTitles[key] || (0, _formatters.toTitleCase)(key))), /*#__PURE__*/_react.default.createElement("pre", null, JSON.stringify(libInfo[key], null, 2)));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeWindow", function () {
      _this.setState({
        isVisible: false
      });
    });

    _this.state = {
      isVisible: false
    }; // sometimes not using state is ok: https://medium.freecodecamp.org/where-do-i-belong-a-guide-to-saving-react-component-data-in-state-store-static-and-this-c49b335e2a00

    _this.lastPress = undefined;
    _this.codeStep = 0;
    return _this;
  }

  _createClass(AppInfoModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.processKey, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.processKey, false);
    } // maybe a little complex, but this basically captures a key sequence(code)

  }, {
    key: "render",
    value: function render() {
      var libInfo = this.props.libInfo;
      var isVisible = this.state.isVisible;
      return /*#__PURE__*/_react.default.createElement(_AppInfoModal.StyledAppInfoModal, {
        className: "app-info-modal",
        isVisible: isVisible
      }, isVisible && /*#__PURE__*/_react.default.createElement("div", {
        className: "innerWrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "infoHeader"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "title"
      }, "App Info"), /*#__PURE__*/_react.default.createElement("button", {
        className: "closeButton",
        onClick: this.closeWindow
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        colorTheme: "cta",
        dataTestId: "app-info-modal-close-icon",
        iconName: "times",
        size: "small"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "data"
      }, /*#__PURE__*/_react.default.createElement(_PrimaryText.default, {
        dataTestId: "app-info-app-version"
      }, /*#__PURE__*/_react.default.createElement("strong", null, "Version")), /*#__PURE__*/_react.default.createElement("div", {
        className: "ourLibs"
      }, libInfo.version), /*#__PURE__*/_react.default.createElement(_PrimaryText.default, {
        dataTestId: "app-info-our-libs"
      }, /*#__PURE__*/_react.default.createElement("strong", null, "Our Libs")), /*#__PURE__*/_react.default.createElement("div", {
        className: "ourLibs"
      }, "Alexandria Version:", ' ', libInfo.dependencies['@cake/alexandria']), /*#__PURE__*/_react.default.createElement("div", {
        className: "ourLibs"
      }, "FE Shared Libs:", ' ', libInfo.dependencies['@cake/fe-shared-libs']), this.buildInfoSections(libInfo))));
    }
  }]);

  return AppInfoModal;
}(_react.default.PureComponent);

_defineProperty(AppInfoModal, "propTypes", {
  /** key sequence to press, activating the modal. Driven off of the event.keyCode */
  accessCode: _propTypes.default.arrayOf(_propTypes.default.string),

  /** max delay between key presses */
  keyDelay: _propTypes.default.number,

  /** JSON data representing installed libs. Format matches package.json */
  libInfo: _propTypes.default.shape({
    version: _propTypes.default.string,
    dependencies: _propTypes.default.object,
    devDependencies: _propTypes.default.object,
    peerDependencies: _propTypes.default.object,
    bundledDependencies: _propTypes.default.object,
    optionalDependencies: _propTypes.default.object
  })
});

_defineProperty(AppInfoModal, "defaultProps", {
  // konami code, by default!
  accessCode: ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight'],
  keyDelay: 500,
  libInfo: {
    version: 'x.x.x',
    dependencies: {},
    devDependencies: {},
    peerDependencies: {},
    bundledDependencies: {},
    optionalDependencies: {}
  }
});

var _default = AppInfoModal;
exports.default = _default;